import React from 'react'
import './Input.css';
export default function Input({placeholder, height}) {
    return (
        <div className='wrapper__input'>
           <input type='text' name="" className="input" placeholder={placeholder} style={{height:height}}/> 
        </div>
    )
}
